"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zustand_1 = require("zustand");
const useGoalTree = (0, zustand_1.create)((set) => ({
    treeObjective: {},
    setTreeObjective: (data) => set({ treeObjective: data })
}));
exports.default = useGoalTree;
